import Vue from 'vue';

export default {
  name: 'NotificationBanner',
  props: {
    text: {
      required: true,
      type: String
    },
    type: { // values error, warning, info
      type: String,
      default: 'error'
    }
  },
  data: function () {
    return { }
  },
  computed: {
    backgroundColor: function () {
      return 'background-color-' + this.type;
    }
  },
  created() { },
  methods:{ }
}
